import { Footer } from "@/components/LandingPage/Footer";
import { Header } from "@/components/LandingPage/Header";

function Paragraph({ children }: { children: string }) {
  return <p className="mt-4">{children}</p>;
}
function SubTitle({ children }: { children: string }) {
  return <h2 className="mt-8 text-xl">{children}</h2>;
}

export default function TermsOfServices() {
  return (
    <>
      <Header dark={false} />
      <div className="flex justify-center pt-32 text-gray-100">
        <div className="max-w-4xl">
          <h1 className="text-2xl bold">Terms of Service for myJson.</h1>
          <Paragraph>
            {`Welcome to myJson! These terms and conditions (the "Terms") govern your access to and use of the myJson SaaS platform ("myJson"), provided by myJson (the "Company," "we," "us," or "our").`}
          </Paragraph>
          <Paragraph>
            By accessing or using myJson, you agree to be bound by these Terms,
            which constitute a binding legal agreement between you and the
            Company. If you do not agree to these Terms, do not use myJson.
          </Paragraph>
          <SubTitle>Use of myJson</SubTitle>
          <Paragraph>{`myJson allows Users to store data on the platform. However, myJson does not take responsibility for any data stored on the platform by Users. Users are solely responsible for the data they store on the platform.`}</Paragraph>
          <Paragraph>
            By using myJson, you represent and warrant that you have the right,
            authority, and capacity to enter into these Terms and to abide by
            all of the terms and conditions set forth herein.
          </Paragraph>
          <SubTitle>User Account and Security</SubTitle>
          <Paragraph>
            In order to use myJson, you may be required to create an account.
            You agree to provide accurate and complete information when creating
            your account, and to update your account information as necessary to
            keep it accurate and complete. You are solely responsible for
            maintaining the confidentiality of your account information, and for
            all activities that occur under your account.
          </Paragraph>
          <Paragraph>
            You agree to immediately notify us of any unauthorized use of your
            account or any other breach of security. We will not be liable for
            any loss or damage arising from your failure to comply with this
            Section.
          </Paragraph>
        </div>
      </div>
      <Footer />
    </>
  );
}
